import './HeaderComponent.scss'
import React, {useEffect, useState} from "react";
import {ProgressBarComponent} from "../progress-bar/ProgressBarComponent";
import {LogoComponent} from "../logo/LogoComponent";
import {useThemeSelector} from "../../../hooks/theme/useThemeSelector";
import { ReactComponent as BackIcon} from "../../../assets/icons/back.svg";

interface HeaderComponentProps {
    title?: string
    subtitle?: string
    progress?: number
    logo?: boolean
    spacer?: boolean
    back?: boolean
    onBackClick?: () => void
}

export const HeaderComponent: React.FC<HeaderComponentProps> = ({title, subtitle, progress, logo, back, spacer, onBackClick}: HeaderComponentProps) => {

    const { theme } = useThemeSelector()
    const [uppercase, setUppercase] = useState(false)

    useEffect(() => {
        if (theme === "squareone") {
            setUppercase(true)
        }
    }, [theme]);

    return (
        <div className={`header-container`}>
            { back && onBackClick &&
                <div className={`width-full flex-start header-back`}>
                    <BackIcon onClick={() => onBackClick()}/>
                </div>
            }
            { progress ?
            (<div className={`header-progress-bar-container ${back ? 'header-back-progress' : ''} width-full`}>
                <ProgressBarComponent fixed progress={progress}/>
            </div>) :
                logo ?
            (<div className={`header-logo-container width-full flex-center`}>
                <LogoComponent/>
            </div>
            ) : (<div className={`header-logo-container-headless width-full flex-center`}></div>)
            }
            {title && <div className={`pick-document-title general-title width-full flex-start`}>
                {uppercase ? title.toUpperCase() : title}
            </div>
            }
            {subtitle && <div className={`pick-document-subtitle general-subtitle width-full flex-start`}>
                {subtitle}
            </div>
            }
            {spacer && <div className={`header-spacer width-full`}></div>}
        </div>
    )
}